import React from "react";
import Page from "../../../components/general/page";
import VatEntriesPage from "../../../components/report/vatEntries";

const VatEntriesView = props => {
  const { pageRef } = props;

  return (
    <Page
      pageRef={pageRef}
      title={"Report IVA"}
      subtitle={""}
      backUrl="/reports/home"
    >
      <VatEntriesPage />
    </Page>
  );
};

export default VatEntriesView;
